var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExerciseVocabulary = function SvgExerciseVocabulary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.615 5.973v22.335c2.041-.194 3.846-.225 5.577-1.166l4.692-2.55c1.477-.803 2.04-2.186 2.04-3.524V8.036c0-3.42-5.082-5.558-8.859-3.506-1.1.598-2.161 1.27-3.45 1.443M15.385 28.308c-2.043-.194-3.53-.225-5.263-1.166l-4.697-2.55c-1.478-.803-2.348-2.063-2.348-3.401V7.85c0-3.42 5.394-5.373 9.174-3.32 1.1.597 1.844 1.268 3.134 1.442z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exercise-vocabulary_svg__a)",
    d: "M15.385 5.986h1.23v22.322h-1.23z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-vocabulary_svg__a",
    x1: 16.01,
    x2: 19.331,
    y1: 33.063,
    y2: 32.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};
export { SvgExerciseVocabulary as ReactComponent };